import React, { useEffect, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { LazyLog } from '@melloware/react-logviewer';
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import { convertTime, isVoid } from '@/utils/common';
import { RESULT_STATUS, getExecResultCodeStatus } from '../../..';

function Log({ log, currentHost }) {
  const ref = useRef();

  const text = useMemo(() => {
    if (isEmpty(log) || isEmpty(currentHost)) {
      return '';
    }
    const prefix = `执行地址：${currentHost.hostIp}\n\n`;
    let logText = log.execRealTimeInfo || '';
    if (getExecResultCodeStatus(log.execResultCode) === RESULT_STATUS.ERROR) {
      logText = `${logText}\n执行失败 耗时: ${convertTime(log.execUse).pretty}`;
    }
    if (getExecResultCodeStatus(log.execResultCode) === RESULT_STATUS.SUCCESS) {
      logText = `${logText}\n执行成功 耗时: ${convertTime(log.execUse).pretty}`;
    }
    return prefix + logText;
  }, [log, currentHost]);

  useEffect(() => {
    if (isVoid(text)) {
      ref.current?.clear();
    }
  }, [text]);

  return (
    <Root>
      <LazyLog
        ref={ref}
        height='600'
        extraLines={1}
        enableSearch
        follow
        caseInsensitive
        enableHotKeys
        text={text}
        selectableLines
      />
    </Root>
  );
}

export default connect((state) => ({
  log: state.execRecord.logs[0],
  currentHost: state.execRecord.currentHost,
}))(Log);

const Root = styled.div`
  margin-top: 10px;
  .react-lazylog {
    scrollbar-color: var(--td-scrollbar-color) transparent;
    scrollbar-width: thin;
    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    ::-webkit-scrollbar-thumb {
      border: 2px solid transparent;
      background-clip: content-box;
      background-color: white;
      border-radius: 15px;
    }
    ::-webkit-scrollbar-thumb:vertical:hover,
    ::-webkit-scrollbar-thumb:horizontal:hover {
      background-color: var(--td-scrollbar-hover-color);
    }
    ::-webkit-scrollbar-corner {
      background-color: #222;
    }
  }
`;
